export const INIT = "MAIN:INIT";
export const ADD_IFI = "MAIN:ADD_IFI";